<template>
    <div class="aclEditor">
        <div class="header">
            <h2>{{$t('aclEditor.title', { user: user })}}</h2>
        </div>
        <div class="body">
            <b-checkbox-group :options="permissionsList" v-model="permissions" stacked switches
                    :disabled="disabled"></b-checkbox-group>
        </div>
        <div class="buttonbar">
            <b-button variant="primary" size="sm" @click="$emit('save', theAcl)"
                    :disabled="!isValid || disabled || state !== ''">{{$t('aclEditor.save')}}
                <FontAwesomeIcon icon="spinner-third" spin v-if="state==='saving'"></FontAwesomeIcon>
            </b-button>
            <b-button @click="onCancel" size="sm" :disabled="state !== ''">{{$t('aclEditor.cancel')}}</b-button>
            <b-button @click="$emit('delete')" size="sm"
                    :disabled="disabled || state !== ''">{{$t('aclEditor.delete')}}
                <FontAwesomeIcon icon="spinner-third" spin v-if="state==='deleting'"></FontAwesomeIcon>
            </b-button>
        </div>
    </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'aclEditor',
  components: { FontAwesomeIcon },
  data: function() {
    return {
      theAcl: ''
    };
  },
  props: {
    acl: Object,
    disabled: Boolean,
    state: {
      type: String,
      default: ''
    }
  },
  watch: {
    acl(newVal) {
      this.theAcl = Object.assign({}, newVal);
    }
  },
  mounted() {
    this.theAcl = Object.assign({}, this.acl);
  },
  methods: {
    onCancel() {
      this.theAcl = Object.assign({}, this.acl);
    }
  },
  computed: {
    allPermissions() {
      return 'lrswikxtea'.split('');
    },
    permissionsList() {
      return this.allPermissions.map(p => {
        return { text: this.$t(`aclEditor.permissions.${p}`),
          value: p,
          disabled: 'lr'.indexOf(p) !== -1
        };
      });
    },
    permissions: {
      get() {
        if (this.theAcl) {
          return this.theAcl.rights.split('');
        }
        return [];
      },
      set(v) {
        this.theAcl.rights = this.allPermissions.filter(p => v.indexOf(p) !== -1).join('');
      }
    },
    isValid() {
      if (this.theAcl) {
        return this.theAcl.rights.indexOf('lr') !== -1;
      } else {
        return false;
      }
    },
    user() {
      if (this.theAcl.type === 'builtin') {
        return this.$t(`acl.builtin.${this.theAcl.name}`);
      } else {
        return this.theAcl.name;
      }
    }
  }
};
</script>

<style scoped lang="scss">
    @import '../assets/bootstrap-style.scss';

    .aclEditor {
        border: 1px solid black;
        background-color: $gray-100;

        margin-top: 10px;
        border-radius: $acl-options-borderradius;
        .header {
            h2 {
                padding: 5px;
                background-color: $dark;
                color: $light;
                margin: 0;
            }
        }
        .body {
            padding: 5px;
        }
        .buttonbar {
            background-color: $white;
            button {
                margin: 10px;
            }
        }
    }

</style>
